export default __webpack_public_path__ + "static/media/conversation-chat.85e57ae5.svg";